module.exports = __webpack_public_path__ + "static/media/VICTORY6.679e925.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/VICTORY6.mp3
// module id = 306
// module chunks = 1 2 3